import React from 'react';

const GOD_COLORS = {
  athena: { bg: 'bg-amber-500/10', border: 'border-amber-500/30', text: 'text-amber-400' },
  hermes: { bg: 'bg-orange-500/10', border: 'border-orange-500/30', text: 'text-orange-400' },
  apollo: { bg: 'bg-yellow-500/10', border: 'border-yellow-500/30', text: 'text-yellow-400' },
  eris: { bg: 'bg-red-500/10', border: 'border-red-500/30', text: 'text-red-400' },
  themis: { bg: 'bg-blue-500/10', border: 'border-blue-500/30', text: 'text-blue-400' },
  calliope: { bg: 'bg-pink-500/10', border: 'border-pink-500/30', text: 'text-pink-400' },
  hestia: { bg: 'bg-orange-400/10', border: 'border-orange-400/30', text: 'text-orange-300' },
  plutus: { bg: 'bg-green-500/10', border: 'border-green-500/30', text: 'text-green-400' },
  nike: { bg: 'bg-yellow-500/10', border: 'border-yellow-500/30', text: 'text-yellow-400' },
  metis: { bg: 'bg-indigo-500/10', border: 'border-indigo-500/30', text: 'text-indigo-400' },
};

const PositionCard = ({ position, index }) => {
  const colors = GOD_COLORS[position.god_id] || { bg: 'bg-gray-800/30', border: 'border-gray-700', text: 'text-gray-400' };
  const isDevil = position.role === 'devil_advocate';

  return (
    <div
      className={`rounded-xl border p-4 transition-all animate-fade-in ${
        isDevil
          ? 'bg-red-900/10 border-red-500/30 ring-1 ring-red-500/10'
          : `${colors.bg} ${colors.border}`
      }`}
      style={{ animationDelay: `${index * 120}ms` }}
      data-testid={`position-card-${position.god_id}`}
    >
      {/* Header */}
      <div className="flex items-center gap-2 mb-3">
        <span className="text-xl">{position.god_emoji}</span>
        <div className="flex-1">
          <span className={`font-bold text-sm ${isDevil ? 'text-red-400' : colors.text}`}>
            {position.god_name}
          </span>
          {isDevil && (
            <span className="ml-2 text-[10px] px-1.5 py-0.5 bg-red-500/20 text-red-400 rounded-full font-semibold">
              DEVIL'S ADVOCATE
            </span>
          )}
        </div>
      </div>

      {/* Thesis */}
      <div className="mb-3">
        <p className="text-[10px] uppercase tracking-wider text-gray-500 font-semibold mb-1">Thesis</p>
        <p className="text-sm text-gray-200 leading-relaxed font-medium">{position.thesis}</p>
      </div>

      {/* Evidence */}
      {position.evidence && (
        <div className="mb-3">
          <p className="text-[10px] uppercase tracking-wider text-gray-500 font-semibold mb-1">Evidence</p>
          <p className="text-xs text-gray-400 leading-relaxed">{position.evidence}</p>
        </div>
      )}

      {/* Risk */}
      {position.risk && (
        <div className="bg-black/20 rounded-lg p-2">
          <p className="text-[10px] uppercase tracking-wider text-orange-500/80 font-semibold mb-1">Risk</p>
          <p className="text-xs text-gray-400 leading-relaxed">{position.risk}</p>
        </div>
      )}
    </div>
  );
};

const PositionsPanel = ({ positions, onProceed, isLoading }) => {
  if (!positions || positions.length === 0) return null;

  return (
    <div className="space-y-4 animate-fade-in" data-testid="positions-panel">
      <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider px-1">
        Each god has staked their position
      </p>

      <div className="grid gap-3 sm:grid-cols-2">
        {positions.map((pos, i) => (
          <PositionCard key={pos.god_id} position={pos} index={i} />
        ))}
      </div>

      <button
        onClick={onProceed}
        disabled={isLoading}
        className="w-full py-3 bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-500 hover:to-orange-500 disabled:opacity-50 text-white font-bold rounded-xl transition-all shadow-lg shadow-red-500/20 hover:shadow-red-500/30 flex items-center justify-center gap-2"
        data-testid="proceed-to-clash-btn"
      >
        {isLoading ? (
          <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
        ) : (
          <>Begin The Clash <span className="text-lg">→</span></>
        )}
      </button>
    </div>
  );
};

export { PositionCard };
export default PositionsPanel;
